import { endOfDay, startOfDay, isAfter, isToday, addMinutes } from 'date-fns'

const jstOffsetTIme = 9 * 60

export const jstNewDate: Date = new Date(
  Date.now() + (new Date().getTimezoneOffset() + jstOffsetTIme) * 60 * 1000
)

const calcJstOffsetMin: () => number = () => {
  return jstNewDate.getTimezoneOffset() + jstOffsetTIme
}

const jstOffsetMin: number = calcJstOffsetMin()

export const endOfJstToDay: Date = endOfDay(jstNewDate)

export const startOfJstToDay: Date = startOfDay(jstNewDate)

export const isPastJstNow: (jstDate: Date) => boolean = (jstDate) =>
  isAfter(jstNewDate, jstDate)

export const isJstToday: (date: Date) => boolean = (date) =>
  isToday(addMinutes(date, jstOffsetMin))

export const isJst: boolean = jstOffsetMin === 0 //TODO: ある程度時計が狂っている場合を考慮する必要がある
